import PropTypes from "prop-types";

const EyeSlashIcon = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1112 7.89172L7.89453 12.1084C7.35286 11.5667 7.01953 10.8251 7.01953 10.0001C7.01953 8.35006 8.35286 7.01672 10.0029 7.01672C10.8279 7.01672 11.5695 7.35006 12.1112 7.89172Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8479 4.80828C13.3896 3.70828 11.7229 3.10828 9.99792 3.10828C7.05625 3.10828 4.31458 4.84161 2.40625 7.84161C1.65625 9.01661 1.65625 10.9916 2.40625 12.1666C3.06458 13.1999 3.83125 14.0916 4.66458 14.8083"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.01953 16.2751C7.96953 16.6751 8.97786 16.8917 10.0029 16.8917C12.9445 16.8917 15.6862 15.1584 17.5945 12.1584C18.3445 10.9834 18.3445 9.0084 17.5945 7.8334C17.3195 7.40006 17.0195 6.99173 16.7112 6.6084"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9281 10.5833C12.7115 11.7583 11.7531 12.7166 10.5781 12.9333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.89297 12.1084L1.66797 18.3334"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3344 1.66663L12.1094 7.89163"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const { string } = PropTypes;

EyeSlashIcon.propTypes = {
  className: string
};

export default EyeSlashIcon;
